import styled from 'styled-components';
import { Card } from '@material-ui/core';

export const Cards = styled(Card)`
  flex-direction: column;
  width: 100%;
  margin-top: 90px;
  height: 800px;
  display: flex;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 600px;
  margin: 10px;
  width: 100%;

`;
export const Footer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: flex-end;
  background-color: #F2F2F2;
  div {
    width: 200px;
  }
`;
export const ColumnForm = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
`;
export const styles = {
  buttom: {
    fontSize: 12,
    marginRight: 10,
    color: 'white',
    backgroundColor: '#333333',
    fontFamily: 'Graphik-Regular',
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginRight: 35,
    marginTop: 6,
  },
  picker: {
    width: 150,
  },
};
